import React from 'react';

interface PricingTeaserProps {
    onSignUp: () => void;
}

const CheckIcon = () => (
    <svg className="w-4 h-4 text-crumborange flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
);

const XIcon = () => (
    <svg className="w-4 h-4 text-gray-300 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const freeFeatures: { label: string; included: boolean }[] = [
    { label: 'Add up to 5 clients', included: true },
    { label: 'Individual & business clients with up to 3 contacts', included: true },
    { label: 'Up to 3 Follow-up reminders per client', included: true },
    { label: 'Log up to 3 interactions per client', included: true },
    { label: 'Dashboard & calendar view', included: true },
    { label: 'File uploads on interactions', included: false },
    { label: 'AI-powered note summaries', included: false },
];

const proFeatures: { label: string; included: boolean }[] = [
    { label: 'Unlimited clients', included: true },
    { label: 'Individual & business clients with contacts', included: true },
    { label: 'Unlimited follow-up reminders', included: true },
    { label: 'Unlimited interaction history', included: true },
    { label: 'Dashboard & calendar view', included: true },
    { label: 'File uploads on interactions', included: true },
    { label: 'AI-powered note summaries', included: true },
];

const PricingTeaser: React.FC<PricingTeaserProps> = ({ onSignUp }) => {
    return (
        <section className="py-20 px-4 bg-white">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-crumbblue mb-3">Simple, honest pricing</h2>
                    <p className="text-gray-500 max-w-xl mx-auto">
                        Start free. Upgrade only when you need more.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 items-stretch">

                    {/* Free tier */}
                    <div className="border border-gray-200 rounded-2xl p-8 flex flex-col">
                        <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-2">Free</p>
                        <p className="text-4xl font-extrabold text-crumbblue mb-1">$0</p>
                        <p className="text-gray-400 text-sm mb-8">Forever free, no credit card needed.</p>
                        <ul className="flex flex-col gap-3 mb-8 flex-grow">
                            {freeFeatures.map((f) => (
                                <li key={f.label} className="flex items-start gap-2 text-sm text-gray-600">
                                    {f.included ? <CheckIcon /> : <XIcon />}
                                    <span className={f.included ? '' : 'text-gray-400'}>{f.label}</span>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={onSignUp}
                            className="w-full py-3 rounded-full border-2 border-crumbblue text-crumbblue font-semibold hover:bg-blue-50 transition"
                        >
                            Get started free
                        </button>
                    </div>

                    {/* Premium tier */}
                    <div className="border-2 border-crumbblue rounded-2xl p-8 flex flex-col relative shadow-md">
            <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-crumborange text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wide">
              Premium
            </span>
                        <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-2">Premium</p>
                        <p className="text-4xl font-extrabold text-crumbblue mb-1">$9.99 / mo</p>
                        <p className="text-gray-400 text-sm mb-8">Full access, including AI features.</p>
                        <ul className="flex flex-col gap-3 mb-8 flex-grow">
                            {proFeatures.map((f) => (
                                <li key={f.label} className="flex items-start gap-2 text-sm text-gray-600">
                                    <CheckIcon />
                                    <span>{f.label}</span>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={onSignUp}
                            className="w-full py-3 rounded-full bg-crumbblue text-white font-semibold"
                        >
                            Sign Up Now
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PricingTeaser;